import React, { useEffect, useState } from "react";

import { ProspectDetails } from "../../../services/v2/prospects.service";
import { hora } from "./salesHelpers";

/**
 * Cliente ajeno abierto por una llamada (Esteban, 2026-10-18): quien contestó la llamada de un cliente de otra asesora
 * solo lo ve, y deja nota durante la llamada y 20 minutos después de colgar. El backend lo cierra igual; esto solo
 * esconde lo que no se puede usar y dice por qué.
 */
export interface AccesoFicha { soloVer: boolean; puedeNota: boolean; duena: string; notaHasta: string | null }

export const useAcceso = (det: ProspectDetails | null): AccesoFicha => {
	const a = det?.acceso;
	const soloVer = a?.modo === "llamada";
	const notaHasta = soloVer ? a?.notaHasta || null : null;
	const fin = notaHasta ? Date.parse(notaHasta) : 0;
	const [, setTic] = useState(0);
	// Al vencer la ventana se esconde el cuadro de nota sin recargar.
	useEffect(() => {
		if (!fin || fin <= Date.now()) return;
		const t = window.setTimeout(() => setTic((n) => n + 1), Math.min(fin - Date.now() + 500, 2147483000));
		return () => window.clearTimeout(t);
	}, [fin]);
	return { soloVer, puedeNota: !soloVer || fin > Date.now(), duena: a?.duena || "otra asesora", notaHasta };
};

export const AvisoSoloVer: React.FC<{ acceso: AccesoFicha; className?: string }> = ({ acceso, className }) => {
	if (!acceso.soloVer) return null;
	return (
		<div className={"aviso-solo-ver " + (className || "")} role="note">
			<b>Solo lectura</b> · Este cliente es de {acceso.duena}.{" "}
			{acceso.puedeNota && acceso.notaHasta
				? <>Contestaste su llamada: puedes dejar nota hasta las {hora(acceso.notaHasta)}.</>
				: <>Contestaste su llamada: puedes verlo, pero lo trabaja su dueña.</>}
		</div>
	);
};
